module.exports = {
	"common": {
		"title": "New buildings - Nedvex",
		"jk": "Residential complex",
		"kp": "Cottage settlement",
		"stopped": "Sales stopped"
	},
	"constants": {
		"view_type": {
			"filter": {
				"intoYard": "Yard",
				"toMountains": "Mountains",
				"onSea": "Sea",
				"toPark": "A park",
				"toGarden": "Garden",
				"toForest": "Forest",
				"onSocialObjects": "Social facilities",
				"panoramicView": "Panoramic view"
			},
			"rightMenu": {
				"intoYard": "Courtyard view",
				"toMountains": "Mountain View",
				"onSea": "Sea view",
				"toPark": "Park view",
				"toGarden": "Garden view",
				"toForest": "Forest view",
				"onSocialObjects": "View of social facilities",
				"panoramicView": "Panoramic view"
			}
		},
		"apartments": {
			"studioAp": "Studio",
			"oneAp": "1 room",
			"twoAp": "2 room",
			"threeAp": "3 room",
			"allAp": "4+",
			"penthaus": "Penthouse"
		},
		"interiors": {
			"all": "Any",
			"chernInt": "Draft",
			"chistInt": "Finishing",
			"whiteBox": "White box",
			"repair": "Renovation, furniture, appliances",
			"predChistInt": "Previous finishing",
			"remInt": "Renovation",
			"chastRemInt": "Partial renovation"
		},
		"features": {
			"concierge": "Concierge",
			"elevator": "Elevator",
			"children_area": "Playground",
			"landscape_decore": "Landscape design",
			"sport_area": "Sports ground",
			"spa": "SPA",
			"fitness": "Fitness",
			"pool": "Pool",
			"kindergarten": "Kindergarten",
			"tennis_court": "Tennis court",
			"recreation_zone": "Lounge zone",
			"fountain": "Fountain",
			"garden": "Garden",
			"helicopter_landing_area": "Helipad",
			"commercial_property": "Commercial space",
			"cctv_surveillance": "CCTV",
			"kpp": "Checkpoint",
			"restaurant": "Restaurant",
			"billiards": "Billiards",
			"sauna": "Sauna",
			"is_children_room": "Children's room",
			"is_conference_hall": "Conference hall",
			"is_wellness_building": "Wellness building",
			"is_panoramic_glazing": "Panoramic glazing",
			"is_beach": "Beach",
			"is_walking_area": "Walking areas",
			"is_operated_roof": "Operated roof",
			"is_garage": "Garage",
			"is_acs_system": "ACS system",
			"is_landscape_park": "Landscape park",
			"is_management_company": "Management company"
		},
		"variants": {
			"selectMicro": "Choose a microdistrict",
			"central": {
				"title": "Central",
				"checkboxes": {
					"1": "Donskoy",
					"2": "Zavokzalny",
					"3": "Zarechny",
					"4": "KSM",
					"5": "Makarenko",
					"6": "Mamaika bottom",
					"7": "Mamaika is on top",
					"8": "New Sochi",
					"9": "Klubnichnay",
					"10": "Centre"
				}
			},
			"hostinskii": {
				"title": "Khostinsky",
				"checkboxes": {
					"11": "Ahun",
					"12": "Bytha",
					"13": "Kudepsta village.",
					"14": "Macesta",
					"15": "Primorye",
					"16": "Razdolnoe",
					"17": "Svetlana Niz",
					"18": "Svetlana verh",
					"19": "Sobolevka",
					"20": "Fabricius",
					"21": "Host",
					"22": "Transport"
				}
			},
			"adler": {
				"title": "Adlersky",
				"checkboxes": {
					"23": "Adler Center",
					"24": "Pancake",
					"25": "Merry village",
					"26": "Blue Distances",
					"27": "Krasnaya Polyana village",
					"28": "The resort town",
					"29": "Peaceful",
					"30": "Moldovka village",
					"31": "Eagle-Emerald village",
					"32": "Southern cultures",
					"33": "Imereti lowland"
				}
			},
			"lazar": {
				"title": "Lazarevsky",
				"checkboxes": {
					"34": "Loo village",
					"35": "Dagomys village",
					"36": "Lazarevskoye settlement"
				}
			},
			"tuapse": {
				"title": "Tuapse",
				"checkboxes": {
					"37": "Tuapse"
				}
			}
		}
	},
	"components": {
		"support": {
			"title": "Technical support",
			"whatsup": "What’s App",
			"telegram": "Telegram",
			"email": "Write by email"
		},
		"cookieBanner": {
			"title": "This site uses cookies to store data. By continuing to use the site, you agree to work with these files.",
			"button": "Accept and close"
		},
		"blocker": {
			"admin": {
				"title": "Access suspended for «{{agencyName}}»",
				"description": "{{tarif}} period has come to an end. To restore access, contact the Nedvex manager",
				"manager": {
					"phone": "+7 (968) 300-01-12",
					"name": "Technical support"
				}
			},
			"worker": {
				"title": "Access suspended for «{{agencyName}}»",
				"description": "{{tarif}} period has come to an end. To restore access, contact the Nedvex manager «{{agencyName}}»."
			},
			"individual": {
				"title": "Access suspended",
				"description": "{{tarif}} period has come to an end. To restore access, proceed to payment",
				"pay": "Go to the payment"
			}
		},
		"appointment": {
			"appointmentButton": {
				"button": "Make an appointment for a viewing"
			},
			"buildingAppointment": {
				"title": "Nearest viewing appointment"
			},
			"appointmentDialog": {
				"stepOneTitle": "CHOOSE TIME",
				"stepTwoTitle": "FILL IN DETAILS",
				"nextButton": "Next",
				"submitButton": "Make an appointment",
				"appointmentForm": {
					"generalInfo": "General information",
					"clientName": "Client name",
					"clientNumber": "Last 4 digits of client number",
					"comment": "Additional comment (max 250 characters)",
					"selectedDate": "Selected date",
					"clientNameRequired": "Enter client name",
					"clientNumberRequired": "Enter last 4 digits of client number"
				},
				"availableSlots": "Available slots",
				"noAvailableSlotsTitle": "No available slots",
				"noAvailableSlotsSubtitle": "Use appointment on another day or contact the sales manager",
				"resultSuccessTitle": "We have sent a request for property viewing",
				"resultSuccessText": "The developer will contact you shortly to arrange the viewing. After confirmation, you will receive a push notification in the app",
				"resultSuccessGood": "OK",
				"resultSuccessToMyAppointment": "To my appointments",
				"resultErrorTitle": "Failed to make an appointment",
				"resultErrorText": "Please try again. If it doesn’t help, log out and log in later",
				"resultErrorNewAppointment": "Reschedule",
				"resultErrorClose": "Close"
			}
		},
		"building": {
			"bar": {
				"finished": "completed",
				"inProcess": "under construction",
				"infoAboutKP": "Information about KP",
				"infoAboutJK": "Information",
				"today": "Today",
				"pavilion": "Building",
				"section": "section",
				"dateUpdated": "Chess update date",
				"dateFrom": "Chess from",
				"list": "List",
				"listTooltip": "View apartments on a checkerboard",
				"chess": "Checkerboard",
				"chessTooltip": "View list of apartments"
			},
			"filters": {
				"price": "Price",
				"area": "Square",
				"inter": "Finishing",
				"housing": {
					"pavilion": "Building",
					"section": "section",
					"finished": "COMPLETED",
					"inProgress": "UNDER CONSTRUCTION",
					"selectPavilion": "Building selection"
				}
			},
			"list": {
				"number": "№",
				"numberS": "№",
				"name": "№",
				"nameS": "№",
				"area": "Square",
				"areaS": "S",
				"cost": "Price",
				"costS": "Price",
				"price": "Per m²",
				"priceS": "Per m²",
				"interior": "Finishing",
				"interiorS": "Finishing",
				"apartments": "Rooms",
				"apartmentsS": "Room",
				"floor": "Floor",
				"floorS": "Floor",
				"floorKp": "Floor",
				"floorKpS": "Floor",
				"promo": "Promotion",
				"reserv": "Booking",
				"assign": "Assignment",
				"№": "№",
				"S": "S",
				"Square": "Area",
				"Price": "Price",
				"Per m²": "Price per m²",
				"Finishing": "Finishing",
				"Rooms": "Rooms",
				"Room": "Rms",
				"Floor": "Floor",
				"Акция": "Promotion",
				"Бронь": "Reservation",
				"Переуступка": "Assignment",
				"soldOutTitle": "All lots are sold",
				"soldOutAlt": "All apartments are sold",
				"cellWithoutReserved": "Apartments on request ({{cellWithoutReserved}})",
				"otherCells": "Other apartments ({{otherCells}})"
			},
			"rightMenu": {
				"addToCollection": "Add to selection",
				"attic": "Attic",
				"area": "{{area}} m²",
				"corps": "Building",
				"floor": "floor",
				"cost": "{{costFormatted}} ₽",
				"section": "section",
				"reserved": "The apartment is reserved by the <br />developer",
				"sold": "Apartment sold",
				"promo": "Promotion",
				"reserve": "Booking",
				"assign": "Assignment",
				"price": "{{priceFormatted}} ₽/m²",
				"predChistInt": "Previous finishing",
				"floorNumber": "{{number}} floor",
				"flatReserved": "THE APARTMENT IS RESERVED BY THE <br />developer",
				"houseReserved": "THE HOUSE IS RESERVED BY THE <br />developer",
				"zoomImg": "Enlarge layout",
				"print": "Printing information about the apartment",
				"emptyPlanning": "No floor plan",
				"priceForM2": "₽/m²",
				"totalArea": "{{totalArea}} cell - land area"
			},
			"tableOptions": {
				"tip": "Checkerboard with detailed information about the apartments",
				"checkbox": "Extended checkerboard"
			},
			"chess": {
				"title": "{{building}} - Apartments in residential complex - Nedvex",
				"Любая": "Any",
				"Черновая": "Rough finish",
				"White box": "White box",
				"Ремонт, мебель, техника": "Renovation, furniture, appliances",
				"Пред. чистовая": "Pre-finish",
				"Ремонт": "Renovated",
				"Частичный ремонт": "Partially renovated",
				"Чистовая": "Finishing",
				"Пентхаус": "Penthouse",
				"Студия": "Studio",
				"1-к": "1 room",
				"2-к": "2 room",
				"3-к": "3 room",
				"4+": "4+ room",
				"Studio": "Studio",
				"Renovation": "Renovation",
				"Renovation, furniture, appliances": "Renovation, furniture, appliances",
				"Previous finishing": "Previous finishing",
				"Partial renovation": "Partial renovation",
				"Draft": "Draft",
				"Finishing": "Finishing",
				"Penthouse": "Penthouse ",
				"1 room": "1 room",
				"2 room": "2 room",
				"3 room": "3 room",
				"4+ room": "4+ room"
			},
			"main": {
				"about": {
					"houseParking": "adjoining",
					"parkingUnderground": "underground",
					"parkingMultilevel": "multilevel",
					"parkingTypeRoofed": "private",
					"noParking": "No",
					"commonInfo": "General characteristics",
					"info": "Characteristics",
					"class": "House class",
					"material": "Building material",
					"type": "House type",
					"houseRoad": "Entrance to the house",
					"parking": "Parking",
					"territory": "Territory",
					"distanceSea": "Distance to the sea",
					"meters": "m.",
					"cealingHeight": "Ceiling height",
					"serviceCost": "Maintenance cost",
					"cost": "{{currency}} / m²",
					"communication": "Communications",
					"gas": "Gas",
					"heating": "Heating",
					"electricity": "Electricity",
					"sewage": "Sewerage",
					"water": "Water supply"
				},
				"chessLink": {
					"seeChess": "Checkerboard",
					"seeList": "Checkerboard",
					"chess": "Checkerboard",
					"list": "List of houses"
				},
				"inaccuracyReport": {
					"add": "Report inaccuracy"
				},
				"inaccuracyReportDialog": {
					"title": "REPORT INACCURACY",
					"subtitle": "Your comment",
					"textAreaPlaceholder": "Describe the inaccuracy in detail",
					"button": "Send",
					"noCharsLeft": "0 characters left",
					"reportSended": "Thank you, your request has been received!",
					"done": "OK"
				},
				"collections": {
					"add": "Add to selection"
				},
				"collectionDialog": {
					"finished": "completed",
					"almostFinished": "Partially completed",
					"finishedBIG": "COMPLETED",
					"inProgress": "UNDER CONSTRUCTION",
					"add": "Add to selection",
					"total": "{{total}} Residential complexes",
					"createNew": "CREATE A NEW SELECTION",
					"enterName": "Enter a name for the new selection",
					"button": "Create selection",
					"done": "Done",
					"empty": "You don't have any selections yet",
					"description": "Create selections of new builds for your clients and share them. Only your contacts will be visible in the selection"
				},
				"contacts": {
					"empty": "Developer contacts missing",
					"contacts": "CONTACTS",
					"subtitle": "Developer and sales department",
					"site": "Website",
					"showContacts": "Show contacts"
				},
				"description": {
					"about": "About {{type}}",
					"readMore": "Read more",
					"more": "More details",
					"minimize": "Collapse"
				},
				"developer": {
					"developer": "Developer",
					"contractor": "General contractor",
					"noInfo": "No information about the developer",
					"note": "Note",
					"commission": "Commission"
				},
				"documents": {
					"title": "Documents"
				},
				"features": {
					"today": "Today",
					"advantages": "Advantages",
					"date": "Date of residential complex info update",
					"updated": "Updated",
					"showAll": "Show all",
					"minimize": "Collapse"
				},
				"formalization": {
					"zhiloeRoom": "Residential space",
					"partFlat": "Share in house",
					"nezhiloeRoom": "Non-residential space",
					"apartmentRoom": "Apartment",
					"apartRoom": "Apartments",
					"zhiloeHouse": "Residential house",
					"commercialPremises": "Commercial space",
					"hotelRoom": "Hotel room",
					"storageRoom": "Storage room",
					"parking": "Parking",
					"title": "Formalization",
					"label": "Formalization options",
					"type": "Property type",
					"sum": "Amount in contract",
					"full": "Full",
					"part": "Partial"
				},
				"gallery": {
					"showAll": "View all photos",
					"showOnMap": "On the map"
				},
				"housing": {
					"name": "Building {{name}}",
					"stopped": "Sales suspended",
					"soldAllHouses": "All houses sold by developer",
					"soldAllFlats": "All apartments sold by developer",
					"flat1": "apartment",
					"flat2": "apartments",
					"flat3": "apartments",
					"finished": "DELIVERED",
					"inProgress": "UNDER CONSTRUCTION",
					"see": "View",
					"see1": "See",
					"chess": "layout",
					"corps": "Buildings {{number}}",
					"prices": "from {{areaMin}} m² to {{areaMax}} m², from {{costMin}} {{currency}} to {{costMax}} {{currency}}"
				},
				"info": {
					"paused": "Sales suspended",
					"stopped": "Sales stopped",
					"house": "house",
					"house1": "houses",
					"house2": "houses",
					"flat": "Apartment",
					"flat1": "Apartments",
					"flat2": "Apartments",
					"soldAllHouses": "All lots sold",
					"soldAllFlats": "All lots sold",
					"minPrice": "{{minPrice}} {{currency}}",
					"price": "Min. price/m²",
					"cost": "Min. price",
					"area": "Area, m²"
				},
				"leftWireframe": {
					"photo": "Photo",
					"info": "Information about the residential complex",
					"flats": "Apartments",
					"advantages": "Advantages",
					"commonAbout": "General characteristics",
					"about": "Characteristics",
					"com": "Communications",
					"decor": "Decor",
					"pay": "Payment",
					"aboutHouse": "About LCD",
					"corp": "Buildings"
				},
				"nav": {
					"photo": "Photo",
					"info": "Information about the residential complex",
					"flats": "Apartments",
					"tip": "Date of updating information about the residential complex",
					"updated": "Updated"
				},
				"news": {
					"titleBig": "News {{title}}",
					"title": "News",
					"readMore": "Read more",
					"seeAll": "See all news"
				},
				"payment": {
					"ipoteka": "Mortgage",
					"installments": "Installment plan",
					"military_ipoteka": "Military mortgage",
					"mat_capital": "Maternal capital",
					"taxes": "VAT refund",
					"cash": "Cash payment",
					"is_ipoteka_family": "Family mortgage",
					"is_ipoteka_state_support": "Mortgage with state support",
					"is_ipoteka_it": "IT mortgage",
					"is_ipoteka_tranche": "Tranche mortgage",
					"is_ipoteka_subsidized": "Subsidized mortgage",
					"is_ipoteka_preferential": "Preferential mortgage",
					"surcharge_balcony": "Surcharge for balcony",
					"surcharge_communications": "Communication surcharge",
					"surcharge_docs": "Surcharge for documents",
					"surcharge_trash": "Waste collection surcharge",
					"gas": "Gas surcharge",
					"pay": "Payment",
					"price": "{{price}} {{currency}}"
				},
				"popup": {
					"photo": "photo"
				},
				"rightWireframe": {
					"social": "I'm on social media",
					"builder": "Developer",
					"commission": "Commission",
					"contacts": "Contacts",
					"docs": "Documents"
				},
				"suggestions": {
					"jk": "Other Objects in the microdistrict {{subregion}}",
					"kp": "Other residential complexes in the microdistrict {{subregion}}"
				},
				"main": {
					"month": {
						"1": "January",
						"2": "February",
						"3": "March",
						"4": "April",
						"5": "May",
						"6": "June",
						"7": "July",
						"8": "August",
						"9": "September",
						"10": "October",
						"11": "November",
						"12": "December"
					},
					"onMap": "On the map",
					"lookOnMap": "View on the map",
					"photo": "{{number}} of {{allNumber}}",
					"title": "{{title}} Information about the residential complex - Nedvex",
					"finished": "completed",
					"inProgress": "UNDER CONSTRUCTION",
					"allOnMap": "View all photos ({{galleryImagesCount}})",
					"noViews": "No layouts of the residential complex available",
					"about": "Description",
					"print": "Preparing information for printing..."
				},
				"printDialog": {
					"item": "Building {{pavilion}}, Section {{section}}",
					"finished": "completed",
					"inProgress": "UNDER CONSTRUCTION",
					"print": "Print",
					"info": "Information about the residential complex",
					"about": "Description of the residential complex",
					"contacts": "Developer contacts",
					"chess": "Chess layout",
					"planning": "Layouts",
					"plans": "Building {{pavilionName}}, Section {{section}}, floor {{floor}}",
					"print1": "Print"
				}
			}
		},
		"buildingCard": {
			"delete": "Delete",
			"finished": "Completed",
			"almostFinished": "Partially completed / rented",
			"flat1": "Apartment",
			"flat2": "Apartments",
			"flat3": "Apartments",
			"lot": "Lot №{{id}}",
			"soldHouses": "All lots sold",
			"soldFlats": "All lots sold",
			"fromFull": "From {{costMin}} ₽, from {{minAreaCost}} ₽ per m²",
			"costMin": "From {{costMin}} ₽",
			"minAreaCost": "{{minAreaCost}} ₽ per m²",
			"goToObject": "Go to residential complex"
		},
		"buildings": {
			"filterLabel": {
				"blackList": "Object of unauthorized construction",
				"new": "New",
				"nedvex": "Nedvex"
			},
			"list": {
				"verified": "Verified Object",
				"house1": "house",
				"house2": "houses",
				"house3": "houses",
				"flat1": "apartment",
				"flat2": "apartments",
				"flat3": "apartments",
				"stopped": "SALES STOPPED",
				"byPromo": "By special offer",
				"byQuery": "Under your request",
				"removeFromFavorites": "Remove residential complex from favorites",
				"addToFavorites": "Add residential complex to favorites",
				"alreadyInFavorites": "Favorites",
				"addTo": "To favorites",
				"addToCollection": "Add residential complex to the selection",
				"toCollection": "Add to selection",
				"promo": "Promotion",
				"promoAds": "Advertisement",
				"finished": "COMPLETED",
				"almostFinished": "Partially completed / rented",
				"inProgress": "UNDER CONSTRUCTION",
				"beforeAgr": "Preliminary agreement",
				"military_ipoteka": "Military mortgage",
				"mat_capital": "Maternal capital",
				"ipoteka": "Mortgage",
				"installments": "Installment plan",
				"paused": "Sales<br />suspended",
				"costMin": "From {{costMin}} ₽",
				"minAreaCost": "From {{minAreaCost}} ₽ per m²",
				"chess": "Checkerboard",
				"square": "{{square}} m²",
				"square12": "{{square1}} m² - {{square2}} m²",
				"stopped2": "Sales stopped",
				"soldHouses": "All houses<br />from the developer<br />are sold",
				"soldFlats": "All<br />lots<br />are sold"
			},
			"news": {
				"title": "News",
				"readMore": "Read more",
				"all": "All",
				"favorite": "Favorite",
				"fromService": "Service"
			},
			"noBuildings": {
				"startNewSearch": "Start new search",
				"notFound": "No objects found",
				"notFoundFull": "We did not find properties matching your request. <br /> Try changing your query or start a new search"
			},
			"buildings": {
				"sorts": {
					"date_updateDESC": "date",
					"cost_minASC": "price increase",
					"cost_minDESC": "price reduction",
					"title": "title"
				},
				"typeFiltersInfo": {
					"nedvex": "NEDVEX",
					"new": "New",
					"promo": "Special offer",
					"orderField": "Popular"
				},
				"searchResults": "Searching results",
				"cottegesPage": "Cottage settlements and townhouses in {{city}}",
				"new": "New buildings in {{city}}",
				"newShort": "New buildings",
				"map": "Map",
				"clear": "Reset",
				"filters": "filters",
				"search1": "Found",
				"search2": "Found",
				"search3": "Found",
				"new1": "an object",
				"new2": "object",
				"new3": "objects",
				"object1": "an object",
				"object2": "object",
				"object3": "objects",
				"by": "By",
				"sortList": "Residential complex list sorting",
				"searchOnMap": "Map",
				"onMap": "On the map",
				"searchOnList": "Search on the list",
				"day": "DAY",
				"week": "WEEK",
				"month": "MONTH"
			}
		},
		"clientCollection": {
			"noPageTitle": "The page has been deleted or does not exist",
			"noPageSubTitle": "If you received this link for review, please inform the sender about the error.",
			"district": "district",
			"costMinASC": "price increase",
			"costMinDESC": "price reduction",
			"sort": "Residential complex list sorting",
			"searchOnMap": "Search on the map",
			"map": "Map"
		},
		"collection": {
			"title": "{{name}} - Selection - Nedvex",
			"myCollections": "My selections",
			"sendCollection": "Share",
			"sendLink": "Send a link to the selection to clients",
			"copy": "Copy",
			"copied": "Link copied",
			"emptyCollection": "Empty selection",
			"description": "Create collections of new builds for your clients and share them. Only your contacts will be visible in the collection",
			"goToList": "Go to the list of objects",
			"allSessions": "All sessions",
			"session": "Session",
			"showAllLots": "Show all lots",
			"onlySelectedLots": "Only selected lots",
			"withoutLots": "Do not display lots",
			"nameAndAddress": "Name and address",
			"descriptionAndAdvantages": "Description and advantages",
			"mainInfo": "General characteristics",
			"communications": "Communications",
			"documents": "Documentation",
			"payments": "Payments",
			"map": "Map",
			"viewsCount": "Number of views",
			"timeSpent": "Time spent",
			"lastVisitDate": "Last visit date",
			"hour": "h",
			"min": "min",
			"sec": "sec"
		},
		"collectionItem": {
			"lot": "Lot №{{buildingId}}",
			"finished": "Completed",
			"almostFinished": "Partially completed / rented",
			"addComment": "Add a comment",
			"comment": "A comment",
			"delete": "Delete",
			"writeComment": "Enter comment text and press Enter",
			"cancel": "Cancel",
			"edit": "Edit",
			"save": "Save",
			"views": "Views",
			"timeSpent": "Time spent",
			"photoClicks": "Photo clicks",
			"mapClicks": "Map clicks",
			"phoneClicks": "Phone number clicks",
			"hour": "h",
			"min": "min",
			"sec": "sec",
			"showLots": "Show lots",
			"LOT": "Lot",
			"corpus": "Corpus",
			"section": "Section",
			"floor": "Floor",
			"lotClicks": "Lot clicks",
			"likeClicks": "Like clicks"
		},
		"collections": {
			"title": "Collections - Nedvex",
			"myCollections": "My selections",
			"create": "Create a collection",
			"noCollections": "You don't have any collections yet",
			"share": "Create collections of new builds for your clients and share them. Only your contacts will be visible in the collection",
			"enterName": "Enter the name of the collection",
			"collection1": "collection",
			"collection2": "collections",
			"collection3": "collections"
		},
		"collectionsItem": {
			"rename": "Rename",
			"description": "{{total}} Residential complex",
			"dup": "Duplicate",
			"del": "Delete",
			"cancel": "Cancel",
			"deleteCollection": "Deleting a collection",
			"sure": "Are you sure you want to delete the collection {{name}}?"
		},
		"collectionsPopup": {
			"title": "Create a collection",
			"enter": "Enter the name of the collection",
			"add": "Save"
		},
		"common": {
			"radioMenu": {
				"select": "Choose a district",
				"clear": "RESET",
				"selectAll": "SELECT ALL"
			},
			"yPlaceInfo": {
				"promo": "Promotion",
				"stopped": "Sales stopped",
				"addToCollection": "Add to selection",
				"finished": "COMPLETED",
				"almostFinished": "Partially completed / rented",
				"inProgress": "UNDER CONSTRUCTION",
				"flat1": "Apartment",
				"flat2": "Apartments",
				"flat3": "Apartments",
				"square": "{{minSquare}} m² - {{maxSquare}} m²",
				"costMin": "From {{costMin}} ₽",
				"minAreaCost": "{{minAreaCost}} ₽ per m²",
				"soldHouses": "All lots sold",
				"soldFlats": "All lots sold",
				"inFavorite": "Favorites",
				"addToFavorite": "To favorites",
				"building1": "building",
				"building2": "buildings",
				"building3": "buildings",
				"andMore": "and more"
			}
		},
		"favorites": {
			"title": "Favorites - Nedvex",
			"titleBlock": "Favorites",
			"count1": "new building",
			"count2": "new buildings",
			"count3": "new buildings",
			"remove": "Remove from favorites",
			"empty": "You don't have anything in your favorites yet",
			"notFound": "Add new buildings to your favorites and they will be visible here"
		},
		"flatsList": {
			"filters": {
				"price": "Price, ₽",
				"area": "Square, m²",
				"from": "from",
				"to": "to",
				"interior": "Finishing"
			},
			"flats": {
				"showMore": "show more"
			},
			"flatListItem": {
				"gallery": {
					"modalName": "Floor plan",
					"floor": "{{floor}} floor"
				},
				"number": "{{number}} floor",
				"reserved": "The apartment is reserved by the<br />developer",
				"sold": "Apartment sold",
				"promo": "Promotion",
				"reserve": "Booking",
				"priceFormatted": "{{priceFormatted}} ₽ per m²",
				"area": "{{area}} m²",
				"predChistInt": "Previous finishing",
				"housing": "Building {{pavilionName}}, section {{sectionName}}",
				"showPlan": "See floor plan",
				"flatNumber": "№ apartments",
				"price": "Price per m²",
				"inner": "Finishing",
				"finished": "Completed",
				"emptyPlan": "No floor plan"
			},
			"subFilters": {
				"flat1": "apartment",
				"flat2": "apartments",
				"flat3": "apartments",
				"sort": "Sort by {{sort}}"
			},
			"flatsList": {
				"sorts": {
					"priceAllAsc": "price increase",
					"priceAllDesc": "price reduction",
					"areaAsc": "increase in area",
					"areaDesc": "area reduction",
					"area": "{{area}} m²",
					"price": "{{price}} ₽/m²"
				},
				"flat1": "Apartment",
				"flat2": "Apartments",
				"flat3": "Apartments",
				"notFound": "There are no suitable apartments for your request",
				"startNewSearch": "Start new search",
				"soldOut": "All apartments are sold",
				"noForSale": "No apartments for sale",
				"soldAllHouses": "Sold all houses from the developer",
				"soldAllFlats": "Sold all apartments from the developer"
			}
		},
		"footer": {
			"innKpp": "INN 2318043183<br/>OGRN 1162366056830",
			"address": "354000, Krasnodar Territory, <br/>Sochi, per. Marine, 1/1a",
			"softDeveloper": "Nedvex LLC is a <br>software developer",
			"copied": "All rights reserved. 2025",
			"docs": "Documentation"
		},
		"header": {
			"buildingTitle": {
				"verified": "Verified Object",
				"finished": "Completed",
				"almostFinished": "Partially completed / rented",
				"inProgress": "Under construction",
				"today": "Today",
				"lot": "Lot №{{id}}",
				"promo": "Promotion",
				"updatedAt": "Date of updating information about the residential complex",
				"updatedFrom": "Information from",
				"addToFavorites": "Add residential complex to favorites",
				"share": "Share a link to an object",
				"print": "Residential complex information printing"
			},
			"clientHeader": {
				"address": "Address",
				"phone": "Telephone",
				"mail": "Email",
				"website": "Web site",
				"backToList": "Back to list"
			},
			"filtersBar": {
				"filters": {
					"viewTypes": {
						"title": "View from the window",
						"chooseViewType": "Choose the view from the window",
						"clear": "Reset",
						"notSelected": "Not selected"
					},
					"advantages": {
						"title": "Advantages",
						"clear": "Reset",
						"parking": "Parking",
						"elevator": "Elevator",
						"concierge": "Concierge",
						"childrenArea": "Playground",
						"recreationZone": "Lounge zone",
						"pool": "Pool",
						"beach": "Beach",
						"restaurant": "Restaurant",
						"operatedRoof": "Operated roof",
						"new": "New",
						"zbbq": "BBQ area",
						"walkingArea": "Walking areas",
						"wellnessBuilding": "Wellness building",
						"houseTerritory": "Closed area",
						"spa": "SPA",
						"cctv": "Video surveillance",
						"commercialProperty": "Commercial premises",
						"sportArea": "Sports ground",
						"kpp": "Checkpoint"
					},
					"area": {
						"title": "Specify the area",
						"clear": "Reset",
						"from": "from",
						"fromFull": "Area from",
						"to": "to",
						"toFull": "Area up to",
						"notSelected": "Not selected"
					},
					"buildingClass": {
						"variant1": "Economy",
						"variant2": "Comfort",
						"variant3": "Business",
						"variant4": "Elite",
						"notSelected": "Not selected",
						"title": "House class",
						"clear": "Reset"
					},
					"deadline": {
						"title": "Choose a completion date",
						"clear": "Reset",
						"finished": "House rented",
						"quarter": "{{data}} quarter",
						"notSelected": "Not selected",
						"deadlineEnd": "House rented"
					},
					"decoration": {
						"clear": "Reset",
						"title": "Finishing",
						"titleFull": "Finishing",
						"chernInt": "Draft",
						"chistInt": "Finishing",
						"predChistInt": "Pre-finishing",
						"whiteBox": "White box",
						"repair": "Renovation, furniture, appliances",
						"remInt": "Renovation",
						"chastRemInt": "Partial renovation",
						"notSelected": "Not selected"
					},
					"interior": {
						"chernInt": "Draft",
						"chistInt": "Finishing",
						"whiteBox": "White box",
						"repair": "Renovation, furniture, appliances",
						"predChistInt": "Pre-finishing",
						"remInt": "Renovation",
						"chastRemInt": "Partial renovation",
						"notSelected": "Not selected",
						"title": "Select type of finish",
						"clear": "Reset"
					},
					"payment": {
						"title": "Payment options",
						"clear": "Reset",
						"notSelected": "Not selected",
						"taxes": "VAT refund",
						"cash": "Cash payment",
						"installments": "Installment plan",
						"mat_capital": "Maternal capital",
						"ipoteka": "Mortgage",
						"military_ipoteka": "Military mortgage",
						"is_ipoteka_family": "Family mortgage",
						"is_ipoteka_state_support": "Mortgage with state support",
						"is_ipoteka_it": "IT mortgage",
						"is_ipoteka_tranche": "Tranche mortgage",
						"is_ipoteka_subsidized": "Subsidized mortgage",
						"is_ipoteka_preferential": "Preferential mortgage"
					},
					"price": {
						"cost": "{{price}} million",
						"perMeter": "{{min}} - {{max}} per m²",
						"notSelected": "Not selected",
						"clear": "Reset",
						"title": "Specify a price",
						"from": "Price from",
						"to": "Price up to",
						"commonPrice": "Total price",
						"commonPriceMeter": "Price per m²",
						"commonPriceWithCurrency": "Total price, {{currency}}",
						"commonPriceMeterWithCurrency": "Price per m², {{currency}}"
					},
					"federalLaw": {
						"fz214": "Federal law 214",
						"fz215": "Federal law 215",
						"notSelected": "Not selected",
						"clear": "Reset",
						"title": "Federal law"
					},
					"registration": {
						"fz214": "Federal law 214",
						"fz215": "Federal law 215",
						"ust": "Justice",
						"inv": "Investment agreement",
						"part": "DDA / Federal law 214",
						"buySale": "Purchase and sale agreement",
						"contract": "Contract agreement",
						"prec": "Preliminary agreement",
						"shared": "Share contribution",
						"reserv": "Booking agreement",
						"loan": "Loan agreement",
						"partnership": "Simple partnership agreement",
						"assignment": "Assignment agreement",
						"notSelected": "Not selected",
						"clear": "Reset",
						"title": "Choose the type of design"
					},
					"sea": {
						"500": "Up to 500 m",
						"1500": "Up to 1500 m",
						"3000": "Up to 3000 m",
						"notSelected": "Not selected",
						"clear": "Reset",
						"title": "Distance to the sea"
					},
					"type": {
						"flat": "Apartment",
						"apt": "Apartments",
						"lvn": "Residential premises",
						"nlvn": "Non-residential premises",
						"hotelRoom": "Hotel room",
						"zhiloeHouse": "Residential house",
						"storageRoom": "Storage room",
						"notSelected": "Not selected",
						"clear": "Reset",
						"title": "Property type"
					},
					"districtTitle": "District",
					"priceTitle": "Price",
					"areaTitle": "Area",
					"registrationTitle": "Registration",
					"deadlineTitle": "Completion",
					"paymentTitle": "Payment options",
					"moreTitle": "More"
				}
			},
			"regionPopup": {
				"title": "Choose a country"
			},
			"search": {
				"title": "Search"
			},
			"user": {
				"tarif": "Tariff «{{tarif}}»",
				"day1": "day",
				"day2": "days",
				"day3": "days",
				"withClient": "I am with a client",
				"language": "Language",
				"profile": "Profile",
				"myProfile": "My profile",
				"companyProfile": "Company profile",
				"logout": "Log out",
				"withClient2": "With a client"
			},
			"menu": {
				"building": "Residential complexes",
				"kpAndTh": "CS & TH",
				"collections": "Compilations",
				"favorites": "Favorites"
			}
		},
		"login": {
			"formRegistration": {
				"workOptions1": "Private agent",
				"workOptions2": "I work in a real estate agency",
				"workOptions3": "I want to connect my agency",
				"title": "Registration in the Nedvex app",
				"nameError": "Name entered incorrectly",
				"name": "Your name",
				"surNameError": "Surname entered incorrectly",
				"surName": "Your last name",
				"currentWork": "Choose your place of work:",
				"currentWorkError": "Choose your position",
				"city": "Choose city:",
				"cityError": "Choose city",
				"phoneNumberError": "Phone number entered incorrectly",
				"emailError": "Email entered incorrectly",
				"email": "Enter your e-mail",
				"send": "SEND",
				"agree": "By clicking the «Send» button, you agree to our ",
				"politicianLink": "Privacy Policy",
				"eulaLink": "User Agreement.",
				"checkboxText": "I agree with",
				"and": "and"
			},
			"formNumber": {
				"userNotFound": "Phone not registered",
				"serverError": "Server error, please try again later",
				"title": "Login to the Nedvex app",
				"button": "ENTER",
				"registration": "REGISTER"
			},
			"formSMS": {
				"title": "Enter the site",
				"smsError": "Invalid authorization code",
				"sms": "Please enter code from SMS",
				"remainingTime": "TRY IN {{remainingTime}} SEC",
				"submit": "Confirm",
				"resend": "Send code again"
			},
			"formTechnicalProblem": {
				"title": "Technical difficulties<br />Try later"
			}
		},
		"notification": {
			"text": "Download insights on the Sochi real estate market from Nedvex experts by completing a short survey.",
			"link": "https://forms.yandex.ru/cloud/67221d87068ff05dd791691f",
			"textEnding": "and learn how to increase sales in the new region",
			"cancel": "Cancel"
		},
		"payments": {
			"failPage": {
				"title": "Payment error",
				"description": "Sorry, we were unable to accept your payment.<br />Try again.",
				"tryMore": "Try again"
			},
			"notification": {
				"title": "{{days}} until the end {{tarif}} {{agencyName}}",
				"company": "paid subscription",
				"personal": "paid subscription",
				"company_test": "free trial period",
				"personal_test": "free trial period",
				"default": "free trial period",
				"day1": "day",
				"day2": "days",
				"day3": "days"
			},
			"payForTarif": {
				"title": "SUBSCRIPTION SELECTION",
				"subtitle": "The remaining days will be saved after payment",
				"tarifImg": "Tariff \"Private\"",
				"tarifSolo": "Tariff \"Individual\"",
				"description": "Your personal access to the service",
				"popular": "Popular",
				"price": "2,000 ₽",
				"time": "1 month",
				"pay": "Pay for a subscription",
				"text": "The remaining days will be saved <br />after payment",
				"button": "Pay",
				"months": {
					"1": "for 1 month",
					"3": "for 3 months",
					"12": "for 12 months"
				}
			},
			"subscriptionBar": {
				"title": "{{countDay}} {{left}}",
				"day1": "day",
				"day2": "days",
				"day3": "days",
				"left1": "remained",
				"left2": "left",
				"left3": "left",
				"ended": "Subscription ended",
				"tarif": "Tariff: «{{tarif}}»",
				"workers": "{{workersCount}} of {{countPeople}} employees",
				"text": "The remaining days will be saved <br />after payment"
			},
			"successPage": {
				"title": "Successful payment",
				"description": "You have successfully paid for your subscription. Thank you! <br />Access to the service has been restored.",
				"goToMain": "Go back to the main page"
			}
		},
		"profile": {
			"avatar": {
				"update": "Update photo",
				"upload": "Upload a photo"
			},
			"tariffModal": {
				"title": "Select tariff",
				"button": "Create an account",
				"current": "current tariff",
				"error": {
					"title": "something went wrong.",
					"default": "An error occurred while generating the invoice. Please try again in a few minutes.",
					"data": "An error occurred while generating the invoice. Check the correctness of the entered TIN and KPP.",
					"count": "You need to reduce the number of employees to {{count}}."
				},
				"emptyInnOrKpp": {
					"title": "Error",
					"body": "It is necessary to fill out the TIN and KPP"
				}
			},
			"avatarUploader": {
				"title": "Your photo",
				"button": "Crop and save"
			},
			"employeeList": {
				"new": "New employee",
				"deny": "You cannot add another employee within the current tariff plan.",
				"allow": "You can add more {{countPeople}} employees",
				"admin": "Administrator",
				"edit": "Edit",
				"delete": "Delete",
				"cancel": "Cancel",
				"deleteWorker": "Deleting an employee",
				"areYouSure": "Are you sure you want to delete an employee {{firstName}} {{lastName}}?"
			},
			"profileForm": {
				"saveButton": "Save changes",
				"logout": "Log out",
				"leaveAgency": "Leave agency",
				"firstName": "Name",
				"firstNameLabel": "Ivan",
				"lastName": "Your last name",
				"lastNameLabel": "Ivanov",
				"phone": "Telephone",
				"email": "Email",
				"position": "Job title",
				"positionPlaceholder": "example@gmail.com",
				"company": "Company",
				"companyPlaceholder": "Company name",
				"about": "Tell us about yourself",
				"aboutPlaceholder": "Enter text up to 250 characters",
				"profileLink": "Link to profile",
				"vk": "Vkontakte",
				"ok": "Odnoklassniki",
				"validate": {
					"firstName": "Enter your name",
					"firstNameError": "Name too long",
					"lastName": "Enter last name",
					"lastNameError": "Surname too long",
					"phone": "Enter phone number",
					"phoneConflict": "Number already registered, contact support",
					"phoneError": "Wrong phone",
					"email": "Enter address",
					"emailError": "Wrong address",
					"emailError1": "Address too long",
					"emailConflict": "Email already registered, contact support",
					"position": "Enter position",
					"positionError": "Post too long",
					"positionError1": "Enter text up to 250 characters"
				},
				"leaveAgencyDialog": {
					"title": "Leave agency?",
					"subtitle": "After leaving the agency you will lose access to the platform. You will need to either get a personal subscription or join another agency",
					"leave": "Leave",
					"cancel": "Cancel"
				},
				"informPopup": {
					"userBindedToAgencyTitle": "User is bound to another agency",
					"userBindedToAgencySubtitle": "To add the user to your agency, they need to leave their current agency",
					"userBindedToAgencyButton": "OK",
					"userAlreadyExistsTitle": "Agent with this number already exists",
					"userAlreadyExistsSubtitle": "Add them to the agency card?",
					"userAlreadyExistsButton": "Add"
				}
			},
			"company": {
				"validate": {
					"name": "Enter company name",
					"nameError": "Too long company name",
					"description": "Enter text up to 500 characters",
					"officeErrors1": "Enter office name",
					"officeErrors2": "Too long office name",
					"address": "Enter address",
					"phone": "Enter phone number",
					"email": "Enter email",
					"emailError": "Address too long",
					"inn": "Enter company tax identification number",
					"kpp": "Enter the company checkpoint"
				},
				"mainOffice": "Main office",
				"anotherOffice": "Additional office",
				"officeName": "Office name",
				"officeNamePlaceholder": "Office in Sochi",
				"officeAddress": "Office address",
				"officeAddressPlaceholder": "Sochi, st. Cooperative, 8",
				"officePhone": "Telephone",
				"officeEmail": "Email",
				"plusOffice": "+ ADDITIONAL OFFICE",
				"title": "Company Profile",
				"commonInfo": "General information",
				"workers": "Employees",
				"form": {
					"name": "Company name",
					"website": "Web site",
					"description": "Company Description",
					"inn": "INN",
					"kpp": "KPP"
				},
				"socialNets": "Social media",
				"save": "Save changes"
			},
			"employerInteraction": {
				"edit": "Edit profile",
				"new": "New employee"
			},
			"profile": {
				"noPermission": "To change contact details, contact the administrator",
				"title": "Edit profile",
				"profileTab": "MY DATA",
				"appointmentsTab": "MY APPOINTMENTS"
			},
			"appointments": {
				"futureAppointments": "FUTURE",
				"pastAppointments": "PAST",
				"noAppointments": "No appointments",
				"noFutureAppointments": "You have not booked any property viewings yet",
				"noPastAppointments": "You have not conducted any property viewings yet",
				"dateAndTime": "Date and time",
				"clientName": "Client name",
				"clientDate": "Client phone",
				"comment": "Comment",
				"agentName": "Agent name",
				"agency": "Agency",
				"inProgress": "IN PROGRESS",
				"appointed": "APPOINTED",
				"completed": "COMPLETED",
				"canceled": "CANCELED",
				"online": "ONLINE",
				"offline": "OFFLINE",
				"today": "Today",
				"yesterday": "Yesterday"
			}
		},
		"realtorCard": {
			"title": "I'm on social media",
			"in": "in"
		},
		"realtorPopup": {
			"office": "Office",
			"onMap": "On the map",
			"minMap": "Collapse map",
			"showMap": "Show map",
			"phone": "Telephone",
			"address": "Address",
			"email": "Email",
			"website": "Web site"
		},
		"searchFullscreen": {
			"constants": {
				"all1": "Enter the name of the residential complex, district, street",
				"all2": "Enter the title",
				"regions": "Enter the name of the district",
				"sub_regions": "Enter the name of the micro district",
				"buildings": "Enter the name of the new building",
				"streets": "Enter street name"
			},
			"filters": {
				"all": "all",
				"buildings": "New buildings",
				"areas": "Districts",
				"neighborhoods": "Neighborhoods",
				"streets": "Streets"
			},
			"all": "all",
			"buildings": "New buildings",
			"areas": "Districts",
			"neighborhoods": "Neighborhoods",
			"streets": "Streets",
			"emptyResults": "Nothing found",
			"emptyResultsDescription": "We did not find anything for your request"
		},
		"shareDialog": {
			"sendObject": "Send object",
			"title": "Which sections will be visible via the link?",
			"hint": "Send object reference to clients",
			"copy": "Copy",
			"copied": "Link copied",
			"savePdfFile": "Download presentation",
			"nameAndAddress": "Name and address",
			"descriptionAndAdvantages": "Description and advantages",
			"mainInfo": "General characteristics",
			"communications": "Communications",
			"documents": "Documentation",
			"payments": "Payments",
			"lots": "Lots"
		},
		"typeFilters": {
			"new": "New",
			"promo": "Special offer",
			"popular": "Popular"
		}
	},
	"containers": {
		"logIn": {
			"title-phone": "Authorization",
			"title-code": "Entering the code",
			"subtitle-phone": "Enter phone number",
			"subtitle-code": "Code",
			"hint-phone-call": "You will receive a bot call. You don't have to answer, remember the last 4 digits",
			"hint-code-call": "Enter the last 4 digits of the number from which the bot called you",
			"hint-phone-sms": "Please provide your phone number. You will receive an SMS message with an authorization code.",
			"hint-code-sms": "Enter 5 digits from SMS",
			"recall": "You can resend the call after {{sec}} seconds.",
			"resend": "You can resend the code after {{sec}} seconds.",
			"doRecall": "Resend call",
			"doResend": "Resend code",
			"error-code-phone": "The last 4 digits of the calling phone number were entered incorrectly",
			"error-code-sms": "Invalid code from SMS message. Try again",
			"registration": "Don't have an account? Register",
			"buttons": {
				"continue": "Continue",
				"bySms": "Login with SMS",
				"byCall": "Login by call",
				"enter": "Enter",
				"back": "Back"
			},
			"description": {
				"1": "Platform",
				"2": "real estate Sochi"
			},
			"footer": {
				"privacy": "Privacy Policy",
				"eula": "User Agreement",
				"inn": "INN 2318043183",
				"ogrn": "OGRN 1162366056830",
				"copyright": "{{year}}. All rights reserved"
			},
			"technicalProblem": {
				"title": "Something went wrong.",
				"phone-call": "Failed to send an outgoing call, try another login method - “Log in with SMS”",
				"phone-sms": "Failed to send code with SMS, try another login method - “Log in by call”"
			}
		},
		"login": {
			"title1": "Sochi real estate platform",
			"title2": "for agents and real estate agencies",
			"tariffs": "Rates",
			"phone1": "9 (968) 3000 112",
			"phone1Link": "89683000113",
			"phone2": "9 (968) 3001 220",
			"phone2Link": "89683001221",
			"description1": "The largest and most up-to-date database of new buildings",
			"description2": "Sochi with the ability to create collections for your clients",
			"about1": "active realtors use our service per month",
			"about2": "Sochi real estate agencies use our platform",
			"about3": "current real estate objects in the application database",
			"about4": "parameters for each object",
			"footer1": "INN 2318043183<br/>OGRN 1162366056830",
			"footer2": "Nedvex LLC is a software developer<br/>",
			"footer3": "All rights reserved. 2025",
			"docs": "Documentation"
		}
	},
	"epics": {
		"addedToCollections1": "{{buildingName}} added to collections",
		"removeFromCollections1": "{{buildingName}} removed from collections",
		"addedToCollections2": "{{buildingName}} added to collection «{{collectionName}}»",
		"removeFromCollections2": "{{buildingName}} removed from collection «{{collectionName}}»",
		"emptyFieldsError": "Required fields not filled",
		"fieldsError": "Fields filled out incorrectly",
		"savedInfo": "Information saved",
		"leavedFromAgency": "You have left the agency",
		"leaveAgencyError": "Failed to leave the agency",
		"deletedCollection": "Collection deleted",
		"registrationSuccessTitle": "Application successfully sent!",
		"registrationSuccessSubtitle": "Thank you! Our manager will contact you to clarify the information",
		"addedToFavorites": "{{buildingName}} added to favorites",
		"deleteFromFavorites": "{{buildingName}} removed from favorites",
		"loadCalendarError": "Failed to book. Please try again later",
		"loadAppointmentStatusesError": "Failed to go to My appointments. Please try again later"
	},
	"utils": {
		"formatDate": {
			"today": "Today",
			"yesterday": "Yesterday"
		},
		"getTarifName": {
			"company": "Agency",
			"personal": "Individual",
			"test": "Test"
		},
		"getTarifPeriodName": {
			"company": "Paid",
			"test": "Test"
		},
		"monthToString": {
			"0": "january",
			"1": "february",
			"2": "march",
			"3": "april",
			"4": "may",
			"5": "june",
			"6": "july",
			"7": "august",
			"8": "september",
			"9": "october",
			"10": "november",
			"11": "december"
		},
		"updateString": {
			"todayAt": "Today at {{time}}"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = 1649
// module chunks = 0